import { render, staticRenderFns } from "./CadastroFinalizadora.vue?vue&type=template&id=468d5a79&scoped=true"
import script from "./CadastroFinalizadora.vue?vue&type=script&lang=js"
export * from "./CadastroFinalizadora.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468d5a79",
  null
  
)

export default component.exports